export default __webpack_public_path__ + "static/media/480_business03-nl-web.eb55e851.png";